import DOMPurify from 'dompurify';
import { Box } from 'styled-system/jsx';

type Props = {
  html?: string | null;
};

export default function HtmlContent({ html }: Props) {
  const cleanHtml = DOMPurify.sanitize(html ?? '', {
    USE_PROFILES: { html: true },

    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'b',
      'em',
      'i',
      'u',
      'h1',
      'h2',
      'h3',
      'h4',
      'ul',
      'ol',
      'li',
      'blockquote',
      'a',
      'img',
      'span',
      'div',
    ],

    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'class', 'style'],

    ALLOWED_URI_REGEXP:
      /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,

    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'style'],
  });

  return (
    <Box
      css={{
        '&, & *': {
          fontFamily: 'iran-yekan !important',
        },
        '& p': {
          margin: '0 0 16px',
          fontSize: '14px !important',
        },

        '& ul': {
          listStyleType: 'disc !important',
          listStylePosition: 'outside',
          paddingInlineStart: '24px !important',
          marginBlock: '12px',
          fontSize: '14px !important',
        },
        '& ol': {
          listStyleType: 'decimal !important',
          listStylePosition: 'outside',
          paddingInlineStart: '24px !important',
          marginBlock: '12px',
          fontSize: '14px !important',
        },
        '& li': {
          display: 'list-item !important',
          marginBottom: '6px',
          fontSize: '14px !important',
        },
        '& a, & a:visited': {
          color: 'purple-primary !important',
          textDecoration: 'underline !important',
          textUnderlineOffset: '2px',
          cursor: 'pointer',
          overflowWrap: 'anywhere',
        },

        '& h1, & h1 *': {
          fontFamily: 'iran-yekan-bold !important',
          fontSize: '20px !important',
          fontWeight: '700 !important',
          lineHeight: '1.5',
        },

        '& h2, & h2 *': {
          fontFamily: 'iran-yekan-bold !important',
          fontSize: '18px !important',
          fontWeight: '700 !important',
          lineHeight: '1.5',
        },

        '& h3, & h3 *': {
          fontFamily: 'iran-yekan-bold !important',
          fontSize: '16px !important',
          fontWeight: '700 !important',
          lineHeight: '1.5',
        },
        '& h1, & h2, & h3': {
          marginBlock: '16px',
        },
        '& img': {
          maxWidth: '100%',
          height: 'auto',
        },
      }}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
}
